import { gql } from '@apollo/client';

const Specific_Keyword_Details = gql`
  query FETCH_KEYWORD_SPECIFIC_PAGE($id: ID!) {
    keywordLandingPage(id: $id) {
      id
      FAQ
      banner_description
      banner_header
      hero_image {
        alternativeText
        url
      }
      meta_description
      meta_title
      page_title
      section2_description
      section2_header
      section2_images {
        alternativeText
        url
      }
      showcase_tour_description
      showcase_tour_header
      showcase_tour_images {
        alternativeText
        url
      }
      showcase_tour_slug
      showcase_tour_badge {
        alternativeText
        url
      }
      Product {
        duration
        id
        images {
          alternativeText
          url
        }
        pickup_available
        price
        rating
        ratingCount
        slug
        title
        city
        country
      }
      seo_section
      canonical
      page_slug
    }
  }
`;

export default Specific_Keyword_Details;
export const FETCH_STRAPI_PRODUCT_ID = gql`
  query FETCH_STRAPI_PRODUCT_ID($slug: String!) {
    strapi_Product(where: { slug: { _eq: $slug } }) {
      id
      price
    }
  }
`;
export const FETCH_REVIEW_AGGREGATE = gql`
  query FETCH_REVIEW_AGGREGATE($id: Int!) {
    strapi_reviews_aggregate(where: { product: { _eq: $id } }) {
      aggregate {
        count
        avg {
          rating
        }
      }
    }
  }
`;
export const FETCH_KEYWORD_SPECIFIC_PAGES_ALL = gql`
  query FETCH_KEYWORD_SPECIFIC_PAGES_ALL {
    keywordLandingPages {
      id
      page_slug
    }
  }
`;
export interface SpecificKeywordData {
  keywordLandingPage: {
    id: string;
    FAQ: string;
    banner_description: string;
    banner_header: string;
    hero_image: {
      alternativeText: string;
      url: string;
    };
    meta_description: string;
    meta_title: string;
    page_title: string;
    page_slug: string;
    canonical: string;
    section2_description: string;
    section2_header: string;
    section2_images: Array<{
      alternativeText: string;
      url: string;
    }>;
    showcase_tour_description: string;
    showcase_tour_header: string;
    showcase_tour_slug: string;
    showcase_tour_images: Array<{
      alternativeText: string;
      url: string;
    }>;
    showcase_tour_badge: {
      alternativeText: string;
      url: string;
    };
    seo_section: string;
    Product: Array<{
      id: string;
      duration: string;
      images: Array<{
        alternativeText: string;
        url: string;
      }>;
      pickup_available: boolean;
      price: string;
      rating: number;
      ratingCount: number;
      slug: string;
      title: string;
      city: string;
      country: string;
    }>;
  };
}
export interface ReviewAggregate {
  strapi_reviews_aggregate: {
    aggregate: {
      count: number;
      avg: {
        rating: number | null;
      };
    };
  };
}

export interface SpecificKeywordPageProps {
  data: SpecificKeywordData;
  reviewAggregate: ReviewAggregate | null;

  productPrice: any;
}
